export const chartLine = {
  chart: {
    type: "spline",
  },
  title: {
    text: "",
  },
  tooltip: {
    style: {
      zIndex: 10003 // Đặt z-index cao hơn so với modal
    }
  },
  xAxis: {
    categories: [],
    labels: { overflow: "allow" },
  },
  yAxis: {
    title: {
      text: undefined,
    },
  },

  credits: {
    enabled: false,
  },
  plotOptions: {
    series: {
      marker: {
        enabled: true,
        radius: 2.5,
      },
      connectNulls: true,
    },
  },
  series: [
    {
      name: "",
      data: [],
    },
  ],
};
